module.exports = __webpack_public_path__ + "static/img/serverShop4.e73ccd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/serverShop4.png
// module id = lfEU
// module chunks = 0